import { useFactory } from '@funtech-int/rival-react';

import { useSearchParams } from '@/shared/hooks/useSearchParams';
import { QueryParameter } from '@/shared/constants/queryParams';

export function useOpenedChannelIdQueryParam() {
    const searchParams = useSearchParams();
    return searchParams.get(QueryParameter.OPENED_CHANNEL_ID) ?? undefined;
}

export function useInitialOpenedChannelIdQueryParam() {
    const searchParams = useSearchParams();

    return useFactory(() => searchParams.get(QueryParameter.OPENED_CHANNEL_ID) ?? undefined);
}
